import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OpcionService {

  apiUrl: string = environment.REST_API.URL;
  constructor(private http: HttpClient) { }

  guardar(opcion) {
    return this.http.post(this.apiUrl + "opcion/guardarOpcion", opcion);
  }

  actualizar(opcion) {
    return this.http.put(this.apiUrl + "opcion/actualizarOpcion", opcion);
  }

  obtenerTodosPorPregunta(idPregunta: number) {
    return this.http.get(this.apiUrl + "opcion/consulaOpcionPregunta?idPregunta=" + idPregunta);
  }

  obtenerPorId(idOpcion: number) {
    return this.http.get(this.apiUrl + "opcion/consultaOpcion?idOpcion=" + idOpcion);
  }

  eliminarPorId(idOpcion: number) {
    return this.http.delete(this.apiUrl + "opcion/eliminarOpcion?idOpcion=" + idOpcion);
  }

}
